import { COLORS } from 'constants/index';
const MuiInputLabel = {
  root: {
    '&$disabled': {
      color: COLORS.BLACK_6,
    },
  },
  formControl: {
    left: '16px',
    top: '9px',
  },
  filled: {
    '&$shrink': {
      transform: 'none',
    },
  },
};

export default MuiInputLabel;
